import { glsHasAnyPrivilege } from '@gls-its-frontends/common/gls-privileges';
import useMainStore from '@/composables/use-main-store';

const hasAnyPrivilege = (privilegesToCheck: string[]): boolean => {
    const { privileges } = useMainStore();

    if (!privilegesToCheck.length) {
        return true;
    }

    return glsHasAnyPrivilege(privileges.value, privilegesToCheck);
};

export { hasAnyPrivilege };
